import React, { useEffect, useState } from 'react'
import { makeStyles, useTheme, SizeProvider, GlobalStyle } from '@seahorse/ui'
import { LineChartOptions } from '@seahorse/charts'
import { Dropdown } from '@seahorse/ui'
import { DateRangePicker } from '@seahorse/ui'
import { fetchNews, fetchChartData } from '../../Utils/Utils'
import ChartTileComponent from '../../Geo-Political/Components/ChartTileComponent'
import EmgptBuddyTile from "../Components/EmgptBuddy";
import ChatTileComponent from "../../Geo-Political/Components/ChatTileComponent";
import InfoFlowTile from '../Components/InfoFlow'


const ComboTile1: React.FunctionComponent = () => {
    const linkStyle = ({
        // maxWidth: "200px", // Set a maximum width for the URL
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "inline-block", // Ensure it's treated as a block-level element for styling
    });

    const theme = useTheme()
    const useStyles = makeStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '50%',
            height: '100%',
            padding: '10px',
        },
        // link: linkStyle,
        container1: {
            overflow: 'auto',
            height: '20%',
            padding: '10px',

        },
        container2: {
            overflow: 'auto',
            height: '40%',
            padding: '10px',

        },
        container3: {
            overflow: 'auto',
            height: '40%',
            padding: '10px',
        },
        container4: {
            overflow: 'auto',
            height: '100%',
            padding: '10px',
            width: '50%'

        },
        root: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'row',

        }
    })

    const classes = useStyles()

    // const fluidFontSizeClassName = useFluidWidgetFontSizeClassName({ min: 10, max: 12 })

    const colors = {
        Pending: theme.globallink.colors.DataTurquoise[500],
        Ineligible: theme.globallink.colors.DataOrange[500],
        Cleared: theme.globallink.colors.DataPurple[500],
        Rejected: theme.globallink.colors.DataAmber[600],
        Dark: theme.globallink.colors.Grey[1100],
        Light: theme.globallink.colors.Slate[900],
    }

    const [selectedCompany, setSelectedCompany] = useState("Bharatiya Janata Party")
    const [newsArticles, setNewsArticles] = useState([])
    useEffect(() => {
        fetchNews(setNewsArticles)
    }, [])



    return (<>
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.container1}>
                    <EmgptBuddyTile />

                </div>
                <div className={classes.container2}>
                    <ChartTileComponent />

                </div>
                <div className={classes.container3}>
                    <ChatTileComponent />

                </div>
            </div>
            <div className={classes.container4}>
                <InfoFlowTile />

            </div>
        </div>
        





    </>

    )
}

export default ComboTile1
